import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState } from "react"

import styles from "styles/header.module.scss"

const routes = [
  {
    name: "Home",
    link: "",
  },
  {
    name: "About us",
    link: "about",
  },
  {
    name: "Solution",
    link: "solutions",
  },
  {
    name: "Features",
    link: "features",
  },
]

const Header = ({ active, isLight, buttonText }) => {
  const [isNavOpen, setNavOpen] = useState(false)
  return (
    <header className={styles.header}>
      <div className="md:h-24 absolute top-0 w-full z-20">
        <div className="w-full lg:w-10/12 mx-auto flex flex-col lg:flex-row items-center h-full justify-between">
          <div className="lg:flex items-center w-full lg:w-auto">
            <div
              className={`flex items-center lg:w-auto w-full justify-between py-5 lg:mt-0 lg:px-0 px-10 ${
                isNavOpen ? "bg-white lg:bg-transparent" : "bg-transparent"
              }`}
            >
              <Link to="/">
                <img src={require("images/logo.svg")} alt="logo" />
              </Link>

              {!isNavOpen ? (
                <div
                  className="lg:hidden block outline-none"
                  role="button"
                  tabIndex={0}
                  onClick={() => setNavOpen(!isNavOpen)}
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      setNavOpen(!isNavOpen)
                    }
                  }}
                >
                  <div
                    style={{ height: "1px" }}
                    className={`w-8 rounded-full ${
                      isLight ? "bg-grey-100" : "bg-grey-100"
                    } `}
                  ></div>
                  <div
                    style={{ height: "1px" }}
                    className={`mt-2 w-8 rounded-full ${
                      isLight ? "bg-grey-100" : "bg-grey-100"
                    } `}
                  ></div>
                  <div
                    style={{ height: "1px" }}
                    className={`mt-2 w-8 rounded-full ${
                      isLight ? "bg-grey-100" : "bg-grey-100"
                    } `}
                  ></div>
                </div>
              ) : (
                <div
                  className="outline-none"
                  role="button"
                  tabIndex={0}
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      setNavOpen(false)
                    }
                  }}
                  onClick={() => setNavOpen(false)}
                >
                  <span className="text-3xl ">&times;</span>
                </div>
              )}
            </div>
            <div className="md:w-auto w-full">
              <nav
                className={`lg:flex items-center lg:pl-16 px-4 lg:px-0 lg:bg-transparent bg-white ${
                  isNavOpen ? "lg:w-auto w-full py-5" : "hidden"
                }`}
              >
                {routes.map(route => (
                  <Link to={"/" + route.link} key={route.name}>
                    <div
                      className={`lg:mr-8 mt-6 lg:mt-0 ${
                        active === route.link ? "border-b-3 border-green" : null
                      }`}
                    >
                      <p
                        style={{ letterSpacing: "0.03em" }}
                        className={`text-base hover:text-green duration-500 ${
                          active === route.link
                            ? "text-green font-semibold"
                            : isLight
                            ? "text-grey-200"
                            : "text-grey-100"
                        }`}
                      >
                        {route.name}
                      </p>
                    </div>
                  </Link>
                ))}
              </nav>
            </div>
          </div>

          <div
            className={`lg:w-auto w-full  px-4 lg:px-0  ${
              isNavOpen
                ? "lg:bg-transparent bg-white"
                : "bg-transparent hidden lg:block"
            } flex justify-between items-center pt-6 md:mt-0 pb-6`}
          >
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://airtable.com/shrPDXj0LnwYEs31P"
              className="text-xs bg-green text-white py-4 rounded-sm px-6 font-semibold hover:bg-green-dark duration-500"
            >
              Deploy a cluster
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}
Header.propTypes = {
  active: PropTypes.string,
  isLight: PropTypes.bool,
  buttonText: PropTypes.string,
}

Header.defaultProps = {
  active: "",
  isLight: false,
  buttonText: "Deploy a cluster",
}

export default Header
